import React, { useState, useEffect, useContext } from 'react'
import {
  CCard,
  CCardBody,
  CCardHeader,
  CForm,
  CFormLabel,
  CFormInput,
  CRow,
  CCol,
  CFormSelect,
  CButton,
} from '@coreui/react'
import PropTypes from 'prop-types'
import { UserContext } from 'src/context/UserContext'
import { AbedanAPI } from './abedanAPI'
import { CircularProgress } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { CONSTANTS } from 'src/constants'
import { convert_to_preeti } from 'src/helpers/PreetiConverter'

const initialState = {
  name: '',
  province: 1,
  status: 1,
  slug: null,
}

const AbedanForm = ({
  open,
  editMode,
  handleClose,
  editData,
  reload,
  setReload,
  fetching,
  selectedId,
}) => {
  // Response State
  const [response, setResponse] = useState({
    success: null,
    error: null,
  })
  // Abedan data
  const [abedanData, setAbedanData] = useState(initialState)

  // Lifecycle method to
  useEffect(() => {
    // console.log(editData)
    if (editData) {
      setAbedanData({
        name: editData.name,
        province: editData.province,
        slug: editData.slug,
        status: editData.status,
      })
    }
  }, [editData])

  useEffect(() => {
    if (open === false) {
      setResponse({
        success: null,
        error: null,
      })
    }
  }, [open])
  // User Context
  const [user] = useContext(UserContext)

  const [loading, setLoading] = useState(false)

  // function to handle abedan data changes
  const handleAbedanDataChange = (e) => {
    setAbedanData({ ...abedanData, [e.target.name]: convert_to_preeti(e.target.value) })
  }

  // Function to create Abedan
  const handleSubmit = (e) => {
    e.preventDefault()
    if (abedanData.name === '' || abedanData.name === null) {
      return
    }

    setLoading(true)

    {
      editMode
        ? AbedanAPI.editAbedan(user.access_token, abedanData, selectedId)
            .then((res) => {
              if (res.data.status === true) {
                setAbedanData(initialState)
                setResponse({
                  error: null,
                  success: 'Abedan has been updated',
                })
                setLoading(false)
              } else {
                console.log(res.data)
                setResponse({
                  error: 'Failed to update',
                  success: null,
                })
                setLoading(false)
              }
            })
            .catch((e) => console.log(e.message))
        : AbedanAPI.createAbedan(user.access_token, abedanData)
            .then((res) => {
              if (res.data.status === true) {
                setLoading(false)
                setAbedanData(initialState)
                setResponse({
                  error: null,
                  success: 'New Abedan has been created',
                })
                setReload(!reload)
              }
            })
            .catch((e) => console.log(e.message))

      setTimeout(
        () =>
          setResponse({
            success: null,
            error: null,
          }),
        CONSTANTS.ALERT_TIME_OUT,
      )
    }
  }

  return (
    <CCard className="mb-4">
      <CCardHeader>{editMode ? 'Edit Abedan' : 'नयाँ मुद्दा'}</CCardHeader>
      <CCardBody>
        {response.success ? <Alert severity="success">{response.success}</Alert> : null}
        {response.error ? <Alert severity="error">{response.error}</Alert> : null}

        {fetching ? (
          <CircularProgress />
        ) : (
          <CForm className={response.success || response.error ? 'mt-4' : null}>
            <CRow>
              <CCol md="12">
                <div className="mb-3">
                  <CFormLabel htmlFor="abedanName">मुद्दा को नाम</CFormLabel>

                  <CFormInput
                    type="text"
                    id="abedanName"
                    placeholder=""
                    name="name"
                    value={abedanData.name}
                    onChange={handleAbedanDataChange}
                  />
                </div>
              </CCol>

              <CCol md="12">
                {loading ? (
                  <CircularProgress />
                ) : (
                  <CButton type="submit" color="primary" size="sm" onClick={handleSubmit}>
                    {editMode ? 'Save' : 'मुद्दा बनाउनुहोस'}
                  </CButton>
                )}
                &nbsp;{' '}
                {editMode ? (
                  <CButton color="danger" size="sm" variant="outline" onClick={handleClose}>
                    Close
                  </CButton>
                ) : null}
              </CCol>
            </CRow>
          </CForm>
        )}
      </CCardBody>
    </CCard>
  )
}

export default AbedanForm

AbedanForm.propTypes = {
  editMode: PropTypes.bool,
  handleClose: PropTypes.func,
}

AbedanForm.defaultProps = {
  editMode: false,
  handleClose: () => console.log('Clicked'),
}
